import React from "react";
import PropTypes from "prop-types";
import {Button, Checkbox, FormGroup, Input, Icon} from "spectre-react/dist/cjs";
import withAbsenceRequestForm from "./withAbsenceRequestForm";
import {transformDayStatusToCSSClass} from "../shared";
import {createCalendarDayStatusOverride} from "../../../api";
import {DAY_STATUS} from "../../shared/constants";
import {
    addKeysToStatusChangesMapping,
    getAvailableButtons,
    getButtonVisibilityLevel,
    SELECTION_MODE,
    TIME_RANGE,
    VISIBILITY_LEVEL
} from "./shared";
import {dmyFmt, isoFmt} from "../../shared/utils";


const statusLabels = {
    VACATION_PAID: 'Хочу в отпуск',
    VACATION_UNPAID: 'Хочу в отпуск за свой счет',
    TIME_OFF_PAID: 'Нужен отгул',
    TIME_OFF_UNPAID: 'Нужен отгул за свой счет',
    WORK_FROM_HOME: 'Работаю из дома',
    WORK_FROM_OFFICE: 'Работаю из офиса',
    ILLNESS: 'Больничный',
};

const statusChangesMapping = addKeysToStatusChangesMapping({
    [DAY_STATUS.ILLNESS]: [],
    [DAY_STATUS.TIME_OFF_PAID]: [],
    [DAY_STATUS.TIME_OFF_UNPAID]: [],
    [DAY_STATUS.TIME_OFF_PAID_PENDING]: [],
    [DAY_STATUS.TIME_OFF_UNPAID_PENDING]: [],
    [DAY_STATUS.VACATION_PAID]: [],
    [DAY_STATUS.VACATION_UNPAID]: [],
    [DAY_STATUS.VACATION_PAID_PENDING]: [],
    [DAY_STATUS.VACATION_UNPAID_PENDING]: [],
    [DAY_STATUS.WORK_FROM_HOME]: [
        {status: DAY_STATUS.WORK_FROM_OFFICE, timeRange: TIME_RANGE.TODAY, selectionMode: SELECTION_MODE.SINGLE},
    ],
    [DAY_STATUS.WORK_FROM_HOME_NWD]: [
        {status: DAY_STATUS.WORK_FROM_OFFICE, timeRange: TIME_RANGE.TODAY, selectionMode: SELECTION_MODE.SINGLE},
    ],
    // [DAY_STATUS.WORK_FROM_OFFICE]: [
    //     {status: DAY_STATUS.WORK_FROM_HOME, timeRange: TIME_RANGE.TODAY, selectionMode: SELECTION_MODE.SINGLE},
    // ],
    // [DAY_STATUS.WORK_FROM_OFFICE_NWD]: [
    //     {status: DAY_STATUS.WORK_FROM_HOME, timeRange: TIME_RANGE.TODAY, selectionMode: SELECTION_MODE.SINGLE},
    // ],
    [DAY_STATUS.FIELD_WORK_HOME_CITY]: [],
    [DAY_STATUS.FIELD_WORK_HOME_CITY_NWD]: [],
    [DAY_STATUS.FIELD_WORK_OTHER_CITY]: [],
    [DAY_STATUS.FIELD_WORK_OTHER_CITY_NWD]: [],
    [DAY_STATUS.EMPTY]: [
        // {status: DAY_STATUS.WORK_FROM_HOME, timeRange: TIME_RANGE.TODAY, selectionMode: SELECTION_MODE.SINGLE},
        {status: DAY_STATUS.WORK_FROM_OFFICE, timeRange: TIME_RANGE.TODAY, selectionMode: SELECTION_MODE.SINGLE},
        {status: DAY_STATUS.TIME_OFF_PAID, timeRange: undefined, selectionMode: undefined},
        {status: DAY_STATUS.TIME_OFF_UNPAID, timeRange: undefined, selectionMode: undefined},
        {status: DAY_STATUS.VACATION_PAID, timeRange: TIME_RANGE.FUTURE, selectionMode: undefined},
        {status: DAY_STATUS.VACATION_UNPAID, timeRange: TIME_RANGE.FUTURE, selectionMode: undefined},
        {status: DAY_STATUS.ILLNESS, timeRange: undefined, selectionMode: undefined},
    ],
})



class EngineerActions extends React.PureComponent {
    static propTypes = {
        selectedDay: PropTypes.instanceOf(Date),
        selectedRange: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
        selectRange: PropTypes.bool,

        toggleSelectRange: PropTypes.func,
        availableStatuses: PropTypes.arrayOf(PropTypes.string),
        onItemCreated: PropTypes.func,

        selectedEngineer: PropTypes.object,
        selectEngineerItems: PropTypes.arrayOf(PropTypes.object),
        onEngineerChange: PropTypes.func,

        calendarType: PropTypes.oneOf(['YEAR', 'MONTH']),
        changeCalendarType: PropTypes.func,

        doOpenAbsenceRequestForm: PropTypes.func
    }

    state = {
        absenceFormOpened: false,
        absenceDayStatus: undefined,

    }

    performAction = async (ev) => {
        const dayStatus = ev.target.parentElement.dataset.status;

        if (dayStatus === DAY_STATUS.TIME_OFF_UNPAID || dayStatus === DAY_STATUS.TIME_OFF_PAID ||
            dayStatus === DAY_STATUS.VACATION_PAID || dayStatus === DAY_STATUS.VACATION_UNPAID ||
            dayStatus === DAY_STATUS.ILLNESS
        ) {
            this.props.doOpenAbsenceRequestForm(dayStatus);
            return;
        }

        const {selectRange, selectedRange, selectedDay} = this.props;

        const affectedEngineerId = this.props.selectedEngineer._id;
        const affectedDates = selectRange
            ? [isoFmt(selectedRange[0]), isoFmt(selectedRange[1])]
            : [isoFmt(selectedDay)];


        const response = await createCalendarDayStatusOverride({
            affectedEngineerId: affectedEngineerId,
            affectedDates: affectedDates,
            dayStatus: dayStatus,
        });

        this.props.onItemCreated(response);
    }

    changeCalendarViewMode = (ev) => this.props.changeCalendarType(ev.target.dataset.value);

    render() {
        const {
            timeline, selectedDay, selectedRange, selectRange, toggleSelectRange, calendarType,
            selectedEngineer, currentUser
        } = this.props;

        const isSelfSelected = selectedEngineer._id === currentUser._id;
        const availableButtons = getAvailableButtons(timeline, selectRange, selectedDay, selectedRange, statusChangesMapping, isSelfSelected);

        return (
            <div id="calendar-actions">
                <FormGroup>
                    <div className="btn-group btn-group-block">
                        <Button data-value="YEAR" active={calendarType === "YEAR"} onClick={this.changeCalendarViewMode}>Год</Button>
                        <Button data-value="MONTH" active={calendarType === "MONTH"} onClick={this.changeCalendarViewMode}>Месяц</Button>
                    </div>
                </FormGroup>

                    <FormGroup>
                        {!selectRange && <div>Выбран день {dmyFmt(selectedDay)}</div>}
                        {selectRange && <div>Выбран период {dmyFmt(selectedRange[0])} - {dmyFmt(selectedRange[1])}</div>}

                        <Checkbox id="selectRange" checked={selectRange} onChange={toggleSelectRange}>
                            Выбрать период
                        </Checkbox>
                    </FormGroup>

                {availableButtons.map(({status, timeRange, selectionMode}) => {
                    const visibilityLevel = getButtonVisibilityLevel({status, timeRange, selectionMode}, selectRange, selectedRange, selectedDay);

                    if (visibilityLevel === VISIBILITY_LEVEL.HIDDEN) {
                        return null;
                    }

                    const isDisabled = visibilityLevel === VISIBILITY_LEVEL.DISABLED;

                    return (
                        <div key={status} data-status={status} className="form-group status-group">
                            <span className={transformDayStatusToCSSClass(status)}></span>
                            <Button block onClick={this.performAction} disabled={isDisabled}>
                                {statusLabels[status]}
                            </Button>
                        </div>
                    );
                })}
            </div>
        );
    }
}

export default withAbsenceRequestForm(EngineerActions);